export enum ResponseStatusEnum {
  Success = "success",
  Error = "error",
}
